// Public routes
import Test from "./test/Test";
import LibraryBooks from "./components/public_directory/library_routes/LibraryBooks";
// _____________________________________________________________
import StudentLogin from "./components/public_directory/public-routs-comps/StudentLogin";
import Registration from "./components/public_directory/public-routs-comps/Registration";
import Stafflogin from "./components/public_directory/public-routs-comps/StaffLogin";
import Library from "./components/public_directory/public-routs-comps/Library";
import Academics from "./components/public_directory/public-routs-comps/Academics";
import Administration from "./components/public_directory/public-routs-comps/Administration";
import Aboutus from "./components/public_directory/public-routs-comps/Aboutus";
import ContactUs from "./components/public_directory/public-routs-comps/Contactus";
import ManagementLogin from "./components/public_directory/public-routs-comps/ManagementLogin";
import AdmissionHub from "./components/public_directory/public-routs-comps/AdmissionHub";
import AcceptedAdmissions from "./components/public_directory/public-routs-comps/admission_hub_Comps/AcceptedAdmissions";
import AdmissionHubDetails from "./components/public_directory/public-routs-comps/AdmissionHubDetails";
import AppLogDetail from "./components/admin_directory/admin_profile_comps/AppLogDetail";
import ApplicationGuide from "./components/public_directory/public-routs-comps/ApplicationGuide";
import AdmissionRequirements from "./components/public_directory/public-routs-comps/AdmissionRequirements";
import StaffIdentity from "./components/developer/StaffIdentity.jsx";
import DevelopingIdentity from "./components/developer/DevelopingIdentity";
import StudentCBTExams from "./computer_base_assessment_components/computer_base_examination/student_components/StudentCBTExams";
// Admin routes
import HomePage from "./components/public_directory/Homepage";
import AdminProfile from "./components/admin_directory/AdminProfile";
import AdmitDetails from "./components/admin_directory/admin_profile_comps/AdmitDetails";
import AdminRegistration from "./components/public_directory/public-routs-comps/AdminRegistration";
import StudentData from "./components/admin_directory/admin_profile_comps/student/StudentData";
import ExaminationCard from "./components/admin_directory/admin_profile_comps/student/ExaminationCard";
import StudentInvoice from "./components/admin_directory/admin_profile_comps/student/StudentInvoice";
import AdmissionConfirmation from "./components/admin_directory/admin_profile_comps/student/AdmissionConfirmation";
// Staffs routes
import StaffAccount from "./components/staff_directory/StaffAccount";
// student routes
import StudentsAccount from "./components/students-directory/Students-account";
import RegistrationForm from "./components/public_directory/public-routs-comps/RegistrationForm";
import RegFormPrinting from "./components/public_directory/public-routs-comps/RegFormPrinting";
import FormReciept from "./components/public_directory/public-routs-comps/FormReciept";
// WEB REAL TIME COMMUNICAITON COMPONENTS
import RTCDashBoards from "./real_time_communication_components/administration_rtc_comps/RTCDashBoards";
import Projector from "./real_time_communication_components/administration_rtc_comps/projector/Projector.jsx";
// COMPUTER BASE COMMUNICATION COMPONENTS
import CBTDashBoards from "./computer_base_assessment_components/computer_base_examination/administrative_components/CBTDashBoards";
import UpdateStudentData from "./components/admin_directory/admin_profile_comps/student/UpdateStudentData.jsx";
import ArchivesAdmHub from "./components/public_directory/public-routs-comps/ArchivesAdmHub.jsx";
import RegistrationByAdmin from "./components/public_directory/public-routs-comps/RegistrationByAdmin.jsx";
const InstitutionalRoutes = [
  // PUBLIC ROUTES
  { path: "/test", name: "home", element: <Test />, isPublic: true },
  { path: "/", name: "home", element: <HomePage />, isPublic: true },
  {
    path: "/student_login",
    name: "student_login",
    element: <StudentLogin />,
    isStudentGuest: true,
  },
  {
    path: "/how_to_apply",
    name: "applicaiton_guide",
    element: <ApplicationGuide />,
    isStudentGuest: true,
  },
  {
    path: "/mangacons_requirement",
    name: "applicaiton_guide",
    element: <AdmissionRequirements />,
    isPublic: true,
  },
  {
    path: "/admin_registration",
    name: "high authority registration",
    element: <AdminRegistration />,
    isPublic: true,
  },
  {
    path: "/library_books",
    name: "library_books",
    element: <LibraryBooks />,
    isPrivate: true,
  },
  {
    path: "/registrations",
    name: "student_apply",
    element: <Registration />,
    isPublic: true,
  },
  {
    path: "/registrations/:appNo/print_reciept",
    name: "student_apply",
    element: <FormReciept />,
    isPublic: true,
  },
  {
    path: "/continue_application/:id",
    name: "student_applicantion",
    element: <RegistrationForm />,
    isPublic: true,
  },
  {
    path: "/continue_application/:id/print_form",
    name: "student_applicantion",
    element: <RegFormPrinting />,
    isPublic: true,
  },

  {
    path: "/admission_status",
    name: "adm status",
    element: <AdmissionHub />,
    isStudentGuest: true,
  },
  {
    path: "/administration/archives/admission_status",
    name: "adm status",
    element: <ArchivesAdmHub />,
    isAdmin: true,
  },
  {
    path: "/admission_status/:appNo/admitted",
    name: "adm status",
    element: <AcceptedAdmissions />,
    isStudentGuest: true,
  },
  {
    path: "/staff_login",
    name: "staff_login",
    element: <Stafflogin />,
    isStudentGuest: true,
  },
  {
    path: "/library",
    name: "library",
    element: <Library />,
    // isPrivate: true,
    isPublic: true,
  },
  {
    path: "/academics",
    name: "academics",
    element: <Academics />,
    isPublic: true,
  },
  {
    path: "/administration",
    name: "admin",
    element: <Administration />,
    isPublic: true,
  },
  {
    path: "/about-us",
    name: "",
    element: <Aboutus />,
    isPublic: true,
  },
  {
    path: "/contact-us",
    name: "",
    element: <ContactUs />,
    isPublic: true,
  },
  {
    path: "/management_login",
    name: "",
    element: <ManagementLogin />,
    isPublic: true,
  },

  // ADMINISTRATION ROUTS
  {
    path: "/admin_profile",
    name: "Admin",
    element: <AdminProfile />,
    isAdmin: true,
  },
  {
    path: "/admin_profile/admit_detail/:id",
    name: "Admin",
    element: <AdmitDetails />,
    isAdmin: true,
  },
  {
    path: "/management/student_data/:adm",
    name: "Admin",
    element: <StudentData />,
    isAdmin: true,
  },
  {
    path: "/management/student_data/:adm/updating",
    name: "Admin",
    element: <UpdateStudentData />,
    isAdmin: true,
  },

  {
    path: "/management/student_data/:adm/exams_card",
    name: "Admin",
    element: <ExaminationCard />,
    isAdmin: true,
  },
  {
    path: "/management/student_data/:adm/comfirmation_letter",
    name: "Admin",
    element: <AdmissionConfirmation />,
    isAdmin: true,
  },
  {
    path: "/management/student_data/:adm/invoice",
    name: "Admin",
    element: <StudentInvoice />,
    isAdmin: true,
  },
  {
    path: "/admin_profile/applicant_log/:id",
    name: "Admin",
    element: <AppLogDetail />,
    isAdmin: true,
  },

  // STAFFS ROUTES
  {
    path: "/staff_profile",
    name: "StaffChat",
    element: <StaffAccount />,
    isStaff: true,
  },

  // STUDENTS ROUTES
  {
    path: "/students/:id/account/:adm/portal",
    name: "studentProfele",
    element: <StudentsAccount />,
    isStudent: true,
  },
 {
    path: "/portal/student_data/:adm/exams_card",
    name: "Admin",
    element: <ExaminationCard />,
    isStudent: true,
  },
  // APPLICANTS ROUTES
  {
    path: "/admission_status/:appNo",
    name: "adm status",
    element: <AdmissionHubDetails />,
    isAdmission: true,
  },

  // total ???pages

  // COMPUTER BASE ASSESSMENT
  {
    path: "/student_profile/assessment",
    name: "student_exams",
    element: <StudentCBTExams />,
    isStudent: true,
  },
  // COMPUTER BASE ASSESSMENT ADMINISTRATION*******************************
  {
    path: "/computer_base_test",
    name: "cbt",
    element: <CBTDashBoards />,
    isAdmin: true,
  },
  // WEB REAL TIME COMMUNICATION COMPONENTS **********************************
  {
    path: "/real_time_communication",
    name: "rtc",
    element: <RTCDashBoards />,
    isAdmin: true,
  },
  {
    path: "/real_time_communication/admin/projector",
    name: "PROJECTOR",
    element: <Projector />,
    isAdmin: true,
  },
  // DEVELOPER ROUTES
  {
    path: "/developer/students/id_cards",
    name: "developer",
    element: <DevelopingIdentity />,
    isAdmin: true,
  },
  {
    path: "/developer/staff-indentity",
    name: "developer",
    element: <StaffIdentity />,
    isAdmin: true,
  },
  {
    path: "/admin/:id/candidate/register_new_applicant",
    name: "developer",
    element: <RegistrationByAdmin />,
    isAdmin: true,
  },
];

export default InstitutionalRoutes;
